import React from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

function TrainerCodeStep({ code, onCodeChange, loading, errorCode, onSubmit }) {
  return (
    <form onSubmit={onSubmit}>
      <TextField
        fullWidth
        label="Access Code"
        value={code}
        onChange={onCodeChange}
        placeholder="XXX-XXX-XXX"
        autoFocus
        inputProps={{ style: { letterSpacing: 2, fontFamily: "monospace" } }}
      />
      <Button type="submit" variant="contained" fullWidth size="large" disabled={loading || errorCode === "ALREADY_CLAIMED"} sx={{ mt: 3, mb: 2 }}>
        {loading ? "Checking..." : "Continue"}
      </Button>
    </form>
  );
}

export default TrainerCodeStep;
